import _pickBy from 'lodash/pickBy';

const queryTypePromissory = {
  CONTRACT: 'contract',
  IDENTIFICATION: 'identification'
};

const queryData = filters => {
  const { queryType, contract, identification, identificationType } = filters;

  const sanitizedFilters = {
    queryType
  };

  if (queryType === queryTypePromissory.CONTRACT) {
    sanitizedFilters.contractId = contract;
  }

  if (queryType === queryTypePromissory.IDENTIFICATION) {
    sanitizedFilters.identification = identification;
    sanitizedFilters.typeOfIdentification = identificationType;
  }

  return _pickBy(sanitizedFilters, filter => !!filter);
};

export default queryData;
